import { createFileRoute } from '@tanstack/react-router'
import { MK8DNav } from '@/components/mk8d/nav'
import { Hero } from '@/components/mk8d/hero'
import { PlayerCard } from '@/components/mk8d/player-card'
import { StatsGrid } from '@/components/mk8d/stats-grid'
import { RaceChart } from '@/components/mk8d/race-chart'
import { TrackBreakdown } from '@/components/mk8d/track-breakdown'
import { DownloadSection } from '@/components/mk8d/download-section'
import { Footer } from '@/components/mk8d/footer'

export const Route = createFileRoute('/_public/')({
  component: Index,
})

function Index() {
  return (
    <div
      style={{
        background: '#08080e',
        minHeight: '100vh',
        fontFamily: "'Barlow', sans-serif",
      }}
    >
      <MK8DNav />
      <Hero />
      <PlayerCard />
      <StatsGrid />
      <RaceChart />
      <TrackBreakdown />
      <DownloadSection />
      <Footer />
    </div>
  )
}
